import React from 'react';
import { Box } from '@mui/material';

/**
 * CompactLayout - Simple layout without sidebar
 *
 * Used for dialogs and embedded contexts (SelectFileDialog)
 * Features:
 * - Single column layout
 * - No preview sidebar
 * - Optimized for space-constrained contexts
 */
export const CompactLayout = ({ children }) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'auto',
      }}
    >
      {children}
    </Box>
  );
};
